import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../../services/PostTemplate";
import LogoImg from "../../../Images/zbizLogo.png";
import { useHistory } from "react-router-dom";

const ChangePasswordOTP = ({ jwt }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");
    let history = useHistory();

    const formik = useFormik({
        initialValues: {
            newPwd: "",
            confirmPassword: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.newPwd) {
                errors.newPwd = "New Password is required.";
            }
            if (!data.confirmPassword) {
                errors.confirmPassword = "Confirm New Password is required.";
            }
            if (data.newPwd !== data.confirmPassword) {
                errors.confirmPassword = "Passwords are not matched";
            }

            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            delete data["confirmPassword"];
            data["jwt"] = jwt;
            await handlePostRequest(data, "zbizgateway/nonFin/resetPassword");
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
            history.push("/");
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    return (
        <>
            <div className="Login__Body">
                <div class="container" id="container">
                    <div class="form-container sign-in-container">
                        <form action="#" className="Login__Form" onSubmit={formik.handleSubmit}>
                            <div className="p-mb-4">
                                <img src={LogoImg} alt="Js-connect" />
                            </div>
                            <div className="p-mb-4">
                                <h3 className="forgetHeading">SET NEW PASSWORD</h3>
                            </div>

                            <div className="p-mt-4">
                                <div className="p-field p-text-left">
                                    <label htmlFor="newPwd" className={classNames({ "p-error": isFormFieldValid("newPwd") })}>
                                        New Password
                                    </label>
                                    <input id="newPwd" className={classNames({ "p-invalid": isFormFieldValid("newPwd") }, "Login__Input")} name="newPwd" value={formik.values.newPwd} placeholder="Enter New Password" onChange={formik.handleChange} type="password" />
                                    {getFormErrorMessage("newPwd")}
                                </div>
                                <div className="p-field p-text-left">
                                    <label htmlFor="confirmPassword" className={classNames({ "p-error": isFormFieldValid("confirmPassword") })}>
                                        Confirm Password
                                    </label>
                                    <input className={classNames({ "p-invalid": isFormFieldValid("confirmPassword") }, "Login__Input")} name="confirmPassword" placeholder="Enter Confirm Password" value={formik.values.confirmPassword} onChange={formik.handleChange} type="password" />
                                    {getFormErrorMessage("confirmPassword")}
                                </div>

                                <div className="p-mt-4">
                                    <Button className="Login__Button" label="Submit" icon={loadingIcon || ""} iconPos="right" disabled={loading} />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChangePasswordOTP;
